import uniqueId from 'lodash/uniqueId';
import moment, { Moment } from 'moment';
import { isProxy, toRaw } from 'vue';

/**
 * @description Rankpicker 时间转换，因为Proxy下的Rank数组 Proxy|Moment统一转换
 * @param MomentArr Moment数组【Proxy|Moment, Proxy|Moment】
 * @param type format类型 默认YYYY-MM-DD
 * @return ['日期', '日期']
 */
export const momentProxyTrans = (MomentArr: [Moment|{}, Moment|{}], type = 'date') => {
  if (MomentArr.length) {
    const format = type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
    let startTime = ''; let endTime = '';
    if (isProxy(MomentArr[0])) {
      startTime = moment(toRaw(MomentArr[0])).format(format);
    } else {
      startTime = moment(MomentArr[0]).format(format);
    }
    if (isProxy(MomentArr[1])) {
      endTime = moment(toRaw(MomentArr[1])).format(format);
    } else {
      endTime = moment(MomentArr[1]).format(format);
    }
    return [startTime, endTime];
  }
  return ['', ''];
};

/**
 * @description 转换单个Moment时间
 * @param MomentData 需要转换的时间 Moment|Proxy
 * @param type format类型 默认YYYY-MM-DD
 * @return 日期|undefined
 */
export const momentTransSingle = (MomentData: Moment|undefined, type = 'date') => {
  if (MomentData) {
    const format = type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
    if (isProxy(MomentData)) {
      return moment(toRaw(MomentData)).format(format);
    }
    return moment(MomentData).format(format);
  }
  return undefined;
};

const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
// const chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
const chnUnitChar = ['', '十', '百', '千'];

export const num2Cn = (num: number) => {
  let strIns = '';
  let chnStr = '';
  let unitPos = 0;
  let zero = true;
  while (num > 0) {
    const v = num % 10;
    if (v === 0) {
      if (!zero) {
        zero = true;
        chnStr = chnNumChar[v] + chnStr;
      }
    } else {
      zero = false;
      strIns = chnNumChar[v];
      strIns += chnUnitChar[unitPos];
      chnStr = strIns + chnStr;
    }
    unitPos += 1;
    num = Math.floor(num / 10);
  }
  return chnStr;
};

/** json深拷贝 */
export const cloneDeep = <T>(data: T): T => JSON.parse(JSON.stringify(data));

export type Uuid<T> = T & {uuid: string}
export const getUuid = <T>(data: T[]): Uuid<T>[] => cloneDeep(data).map((v) => ({ ...v, uuid: uniqueId('') }));

interface Obj {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [index: string]: any;
}
/**
 * jsonObj => formData
 * 对象转formData格式
 */
export const obj2form = (data: Obj): FormData => {
  const resData = new FormData();
  const ks = Object.keys(data);
  ks.forEach((k) => {
    resData.append(k, data[k]);
  });
  return resData;
};

export const getDateForName = (name?: string) => {
  const time = new Date();
  const date = time.getDate().toString().length > 1 ? time.getDate().toString() : `0${time.getDate()}`;
  const month = time.getMonth().toString().length > 1
    ? (time.getMonth() + 1).toString()
    : `0${time.getMonth() + 1}`;
  const newName = `${name} ${month}${date}`;
  return newName;
};

/** 最大100 */
export const textMaxStr = (str: string, num = 100) => {
  // 1 是...的长度
  if (str.length > num - 1) return `${str.slice(0, num - 1)}...`;
  return str;
};
